import React, { useEffect, useState } from 'react';
import TranslationEquivalent from './TranslationEquivalent';
import { getDictionaryOrder } from '../Terms/TermDictionaries/TermDictionaries';
import Spinner from 'react-bootstrap/Spinner';
import { useParser } from './useParser';
import MandalaSkeleton from '../common/MandalaSkeleton';
import { useDictionaryStore } from '../../hooks/useDictionaryStore';
import { getHash, scrollToId, UnicodeDisplay } from '../common/utils';

export default function TranslationResults({ data }) {
    const { parser } = useDictionaryStore();

    // console.log('data in trans results', data);
    const [dorder, setDOrder] = useState({});

    // console.log('Data in results', data);
    useEffect(() => {
        getDictionaryOrder().then((data) => setDOrder(data));
    }, []);

    let results = false;
    if (data?.words) {
        // console.log('Data', data);
        results = Object.keys(data.words).map((w, n) => {
            const tid = data.words[w].length === 0 ? 'nf' : data.words[w][1];
            const lu = w + ':' + tid;
            return (
                <TranslationEquivalent
                    key={[tid, n]}
                    lookup={lu}
                    dictmeta={dorder}
                />
            );
        });
    }

    const parsermsg =
        parser === 'php' ? (
            <p>Be patient... The PHP parser is slower...</p>
        ) : null;
    return (
        <div className="results-wrap">
            <h2>Results</h2>
            <TTToc data={data} />
            <div id="results">
                {!results && (
                    <div className="spinner-wrap">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        {parsermsg}
                    </div>
                )}
                {results}
            </div>
        </div>
    );
}

function TTToc({ data }) {
    /*let tttoc = data.tokens.map((token, i) => {
        if (i % 2 === 0) {
            return <><a key={i} href={ '#' + token }><UnicodeDisplay w={token} /> </a> <span class="sep">| </span></>;
        }
    });*/
    let tttoc = [];
    Object.keys(data.words).map((w, n) => {
        const hash = getHash(w);
        tttoc.push(
            <React.Fragment key={n}>
                <a
                    onClick={() => {
                        scrollToId(hash);
                    }}
                >
                    <UnicodeDisplay w={w} />{' '}
                </a>{' '}
                <span className="sep">| </span>
            </React.Fragment>
        );
    });
    return (
        <div className="ttt-toc">
            <strong>Jump to: </strong> {tttoc}
        </div>
    );
}

// I believe this is deprecated
function LoadTranslations({ data, dictmeta }) {
    const {
        isLoading: isParserLoading,
        data: results,
        isError: isParsingError,
        error: parseError,
    } = useParser(data);

    if (isParserLoading) {
        return <MandalaSkeleton />;
    }

    // Stop the cycle when there are no more words returned.
    if (!results?.words) {
        return null;
    }

    // Map words to trnaslation equivalents
    const transequivs = results?.words?.map((w, n) => {
        return (
            <TranslationEquivalent
                key={[w, n]}
                lookup={w}
                dictmeta={dictmeta}
            />
        );
    });

    return (
        <>
            {transequivs}
            {results?.undone?.length > 0 && (
                <LoadTranslations data={results} dictmeta={dictmeta} />
            )}
        </>
    );
}
